import html2canvas from "html2canvas";
import jsPDF from "jspdf";

export function random (min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

/**
 * Randomize array element order in-place.
 * Using Durstenfeld shuffle algorithm.
 */
export const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1))
    let temp = array[i]
    array[i] = array[j]
    array[j] = temp
  }
  return array
}

export const stringPick = function(str, min, max) {
  let n, chars = '';
  if (typeof max === 'undefined') {
    n = min;
  } else {
    n = min + Math.floor(Math.random() * (max - min + 1));
  }
  for (let i = 0; i < n; i++) {
    chars += str.charAt(Math.floor(Math.random() * str.length));
  }
  return chars;
};


// Credit to @Christoph: http://stackoverflow.com/a/962890/464744
export const stringShuffle = function(str) {
  let array = str.split('');
  let tmp, current, top = array.length;

  if (top) while (--top) {
    current = Math.floor(Math.random() * (top + 1));
    tmp = array[current];
    array[current] = array[top];
    array[top] = tmp;
  }

  return array.join('');
};

export const downloadHtmlCanvas = (ref, fileName) => {
  html2canvas(ref).then(canvas => {
    const pdf = new jsPDF(ref.offsetHeight > ref.offsetWidth ? "p" : "l", "pt", [
      ref.offsetWidth,
      ref.offsetHeight,
    ]);

    pdf.addImage(canvas.toDataURL(), 'PNG', 0, 0, ref.offsetWidth, ref.offsetHeight)
    pdf.save(fileName)
  });
}
